import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const CPF = {
	name: NAME,
	apiProvider,
	router,
};
